// extracted by mini-css-extract-plugin
module.exports = {"Button":"IconButton_Button__BLyLt","CurrentMenuItem":"IconButton_CurrentMenuItem__2vmoK","smoothup":"IconButton_smoothup__1runZ","FadeIcon":"IconButton_FadeIcon__7UbxI"};